import Open from "@pages/Support/Open";
import OpenDetails from "@pages/Support/Edit/OpenDetails";
import ClientListActive from "@pages/ClientList/Active";
import ClientListInActive from "@pages/ClientList/Inactive";
import ClientlistDetails from "@pages/ClientList/Active/Clientlist-Details";
import Setup from "@pages/ClientList/Active/Clientlist-Details/setup/index";
import MappedCheckpoint from "@pages/ClientList/Active/Clientlist-Details/MappedCheckpoint";
import ClientlistUsers from "@pages/ClientList/Active/Clientlist-Details/Users";
import CheckpointMaster from "@pages/ClientList/Active/Clientlist-Details/CheckpointMaster";
import ClientCompliance from "@pages/Activity/Compliance";
import ClientActivityLicense from "@pages/Activity/License";
import CustomTable from "@components/common/CustomTable/Table";

export const UnusedRoutes = [
	//Support
	// {
	// 	path: "/support/open",
	// 	name: "Open",
	// 	component: Open,
	// },
	// {
	// 	path: "/support/details",
	// 	name: "OpenDetails",
	// 	component: OpenDetails,
	// },
	// {
	// 	path: "/support/details/:id",
	// 	name: "OpenDetails",
	// 	component: OpenDetails,
	// },

	// //client-list
	// {
	// 	path: "/clientlist/active",
	// 	name: "ClientList",
	// 	component: ClientListActive,
	// },
	// {
	// 	path: "/add-clientlist/profile/:id",
	// 	name: "ClientList",
	// 	component: ClientlistDetails,
	// },
	// {
	// 	path: "/clientlist/inactive",
	// 	name: "ClientList",
	// 	component: ClientListInActive,
	// },
	// {
	// 	path: "/add-clientlist/profile/:id",
	// 	name: "ClientList",
	// 	component: ClientlistDetails,
	// },
	// {
	// 	path: "/add-clientlist/profile",
	// 	name: "ClientlistDetails",
	// 	component: ClientlistDetails,
	// },
	// {
	// 	path: "/add-clientlist/setup",
	// 	name: "Setup",
	// 	component: Setup,
	// },
	// {
	// 	path: "/add-clientlist/users",
	// 	name: "ClientlistUsers",
	// 	component: ClientlistUsers,
	// },
	// {
	// 	path: "/add-clientlist/mapped-checkpoint",
	// 	name: "MappedCheckpoint",
	// 	component: MappedCheckpoint,
	// },
	// {
	// 	path: "/add-clientlist/checkpoint-master",
	// 	name: "CheckpointMaster",
	// 	component: CheckpointMaster,
	// },

	// // activity

	// {
	// 	path: "/activity/compliance",
	// 	name: "Checkpoint",
	// 	component: ClientCompliance,
	// },
	// {
	// 	path: "/activity/license",
	// 	name: "Checkpoint",
	// 	component: ClientActivityLicense,
	// },
	// {
	// 	path: "/custom-table",
	// 	name: "CustomTable",
	// 	component: CustomTable,
	// },
];
